import { environment } from 'projects/environments/environment';
import { externalCommonAspURL, externalNetcoreURL } from 'projects/lib-shared-common/src/public-api';
import { AuthStatus } from './model/user-auth.model';

// AB#70106 - AuthGuard only gates on token validity (see AuthService.check()), never on the
// user's actual backend status, so a Rejected/Pending user with a stale-but-unexpired token
// sails straight into a route whose data can't fully load instead of being sent to the matching
// user-locked/* screen. Returns the route to redirect to for any status that isn't fully signed
// in, or null when the status is allowed through (Employee/Supplier/Contractor).
export function getUserLockedRedirectForStatus(status: AuthStatus): string[] | null {
  switch (status) {
    case AuthStatus.TemporaryPasswordUser:
      return ['reset-password'];
    case AuthStatus.NotFoundUser:
      return ['user-locked/new'];
    case AuthStatus.PermissionPendingUser:
      return ['user-locked/waiting'];
    case AuthStatus.PendingGDPRUser:
      return ['user-locked/gdpr'];
    case AuthStatus.RejectedUser:
      return ['user-locked/rejected'];
    case AuthStatus.MandatoryFederatedUser:
      return ['sign-in'];
    case AuthStatus.EmployeeUser:
    case AuthStatus.SupplierUser:
    case AuthStatus.ContractorUser:
      return null;
    default:
      return ['sign-in'];
  }
}

export function canRedirectToAspFromQueryParamData(queryParamData: string) {
  return (queryParamData ?? '').split('/').length === 2;
}

export function canRedirectToCoreFromQueryParamData(queryParamData: string) {
  return (queryParamData ?? '').split('/').length === 4;
}

export function tryToRedirectToAspFromQueryParamData(queryParamData: string) {
  const splittedValues = (queryParamData ?? '').split('/');
  if (splittedValues.length === 2) {
    const aspParams = { system: splittedValues[0], redirectId: splittedValues[1] };
    const aspUrl = `${environment.isLocalhost ? 'https://devsp.solvacelabs.com' : location.origin}/systems/application/default.asp`;
    externalCommonAspURL(aspUrl, aspParams, false);
    return true;
  }
  return false;
}

export function tryToRedirectToCoreFromQueryParamData(queryParamData: string) {
  const splittedValues = (queryParamData ?? '').split('/');
  if (splittedValues.length === 4) {
    const coreUrl = (environment.isLocalhost ? 'https://devsp.solvacelabs.com' : location.origin) + '/' + splittedValues[0];
    const controller = splittedValues[1];
    const action = splittedValues[2];
    const redirectId = splittedValues[3];
    externalNetcoreURL(coreUrl, `{controller=${controller}||action=${action}||variables={redirectId=${redirectId ?? 0}}}`, false);
    return true;
  }
  return false;
}
